import { ADD_MESSAGE, CLOSE_MESSAGE } from '../types';

export function addMessage(message, variant, imageUrl = '', mobileImageUrl = '', link = '') {
  return { type: ADD_MESSAGE, message, variant, imageUrl, mobileImageUrl, link }
}

export function closeMessage() {
  return { type: CLOSE_MESSAGE }
}
